import { getRouteParams } from './getRouteParams';
export const getMicroappKey = () => {
  return getRouteParams().microappKey;
};